export class DialogForceConnectionData {
	/**
	 * Constructeur.
	 * @param login Login de l'utilisateur.
	 */
	public constructor(public login: string) {}
}
